import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import styles from './Navigation.module.css';
import {
  HomeIcon,
  SearchIcon,
  BookIcon,
  UserIcon,
  SettingsIcon,
  MoonIcon,
  SunIcon,
} from './Icons';

const Navigation = () => {
  const { user, logout } = useAuth();
  const { toggleTheme, isDark } = useTheme();
  const navItems = [
    {
      path: '/',
      label: '首页',
      icon: <HomeIcon size={20} />
    },
    {
      path: '/discover',
      label: '发现',
      icon: <SearchIcon size={20} />
    },
    {
      path: '/study',
      label: '学习',
      icon: <BookIcon size={20} />
    },
    {
      path: '/profile',
      label: '我的',
      icon: <UserIcon size={20} />
    }
  ];

  return (
    <nav className={styles.navigation}>
      <div className={styles.navContainer}>
        <div className={styles.brand}>
          <div className={styles.brandIcon} aria-hidden="true">
            <span className="material-icons-round" style={{ color: '#fff' }}>
              auto_stories
            </span>
          </div>
          <span className={styles.brandLabel}>EnNovels</span>
        </div>
        <div className={styles.navList}>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
              }
              end={item.path === '/'}
            >
              <span className={styles.navIcon}>{item.icon}</span>
              <span className={styles.navLabel}>{item.label}</span>
            </NavLink>
          ))}

          {/* 管理员入口 - 只对管理员显示 */}
          {user?.is_admin && (
            <NavLink
              to="/admin"
              className={({ isActive }) =>
                `${styles.navItem} ${styles.adminItem} ${isActive ? styles.navItemActive : ''}`
              }
            >
              <span className={styles.navIcon}>
                <SettingsIcon size={20} />
              </span>
              <span className={styles.navLabel}>管理</span>
            </NavLink>
          )}
        </div>
        <div className={styles.navActions}>
          <button
            type="button"
            className={styles.actionBtn}
            onClick={toggleTheme}
            aria-label={isDark ? '切换到浅色模式' : '切换到夜晚模式'}
          >
            <span className={styles.actionIcon}>
              {isDark ? <SunIcon size={18} /> : <MoonIcon size={18} />}
            </span>
            <span className={styles.actionLabel}>
              {isDark ? '浅色模式' : '夜晚模式'}
            </span>
          </button>
          <button
            type="button"
            className={`${styles.actionBtn} ${styles.actionBtnDanger}`}
            onClick={logout}
          >
            <span className={styles.actionIcon}>
              <span className="material-symbols-outlined" style={{ fontSize: 18 }}>logout</span>
            </span>
            <span className={styles.actionLabel}>退出登录</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
